import { useState, useEffect } from 'react';
import { Wrapper } from '../../styles/SearchBooksStyle';
import { getListOfBooksByAgeGroup, searchBooksByQuery } from '../../../controller/bookSelection/bookSelectionController';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const BookSelector = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const { bookList, totalBook, next, previous, isLoading, error } = useSelector(
    (state) => state.bookSelection
  );

  const labelFor = {
  children: "Child",
  teen:     "Teen",
  adults:   "Adult"
};

  const [ageGroup, setAgeGroup] = useState("children");
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOpen, setSortOpen] = useState(false);
  const [sortBy, setSortBy] = useState("popular");


  useEffect(() => {
    if (!searchQuery) {
      dispatch(getListOfBooksByAgeGroup({ ageGroup, sortBy, page, pageSize:rowsPerPage }));
    }
  }, [dispatch, ageGroup, sortBy, searchQuery, page, rowsPerPage]);

  const performSearch = () => {
    if (searchQuery.trim()) {
      dispatch(searchBooksByQuery({ query:searchQuery, page, pageSize:rowsPerPage }));
    }
  };

  const handlePrev = () => {
    if (previous) setPage(p => p - 1);
  };
  const handleNext = () => {
    if (next) setPage(p => p + 1);
  };

  const handleBookSelected = book => {
    navigate(`/add-books/${book.id}`, {
      state: { ageGroup: labelFor[ageGroup] }
    });
  }

  return (
    <Wrapper>
      <div className="age-group-filter">
        {["children", "teen", "adults"].map((grp) => (
          <label key={grp}>
            <input
              type="radio"
              name="age"
              value={grp}
              checked={ageGroup === grp}
              onChange={() => { setSearchQuery(""); setAgeGroup(grp); }}
            />
            {grp.charAt(0).toUpperCase() + grp.slice(1)}
          </label>
        ))}
      </div>

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search for books..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') performSearch();
          }}
        />
        {searchQuery && <button onClick={() => setSearchQuery("")}>✕</button>}
        <button onClick={performSearch}>🔍</button>
      </div>

      <div className="sort-button-wrapper">
        <button onClick={() => setSortOpen(o => !o)}>Sort</button>
        {sortOpen && (
          <>
            <div className="overlay" onClick={() => setSortOpen(false)} />
            <div className="sort-popup">
              <div className="sort-header">
                <span>Sort By</span>
                <button onClick={() => setSortOpen(false)}>✕</button>
              </div>
              {["popular", "fiction", "history", "horror"].map(opt => (
                <button
                  key={opt}
                  onClick={() => { setSortBy(opt); setSortOpen(false); }}
                >{opt.charAt(0).toUpperCase() + opt.slice(1)}</button>
              ))}
            </div>
          </>
        )}
      </div>

      {isLoading && <p>Loading...</p>}
      {error && <p>Error: {error}</p>}

      <div className="book-grid">
        {!isLoading && bookList.map(book => (
          <div className="book-card" key={book.id} onClick={() => handleBookSelected(book)}>
            <div className="cover">
              {book.formats["image/jpeg"] ? (
                <img src={book.formats["image/jpeg"]} alt={book.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : <span>No Image</span>}
            </div>
            <div className="meta">
              <p className="title">{book.title}</p>
              <p className="author"><strong className='book-desc-label'>Author</strong>: {book.authors[0]?.name || 'Unknown'}</p>
              <p className="copyright">Copyright: {book.copyright ? 'Yes' : 'No'}</p>
            </div>
          </div>
        ))}
      </div>
      {/* pagination UI */}
      <div className="pagination">
        <label>
          Rows per page:
          <select
            value={rowsPerPage}
            onChange={e => {
              setRowsPerPage(Number(e.target.value));
              setPage(1); // reset to first page
            }}
          >
            {[50, 100, 150].map(n => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </label>

        <span>
          Page {page} • {totalBook} total
        </span>

        <button onClick={handlePrev} disabled={!previous}>
          {'<'} Prev
        </button>
        <button onClick={handleNext} disabled={!next}>
          Next {'>'}
        </button>
      </div>
    </Wrapper>
  );
};

export default BookSelector;